// removed by extract-text-webpack-plugin
module.exports = {"logoRoot":"logoRoot--df589"};